module.exports = __webpack_public_path__ + "static/media/4-iron.1bf71c54.png";